import { Form, FormInstance } from "antd";
import { useEffect } from "react";
import ReactQuill from "react-quill-new";

interface Props {
  form: FormInstance;
}

export const EssayQuestion = ({ form }: Props) => {
  useEffect(() => {
    form.setFieldsValue({ answers: [{ value: "" }] });
  }, []);

  return (
    <Form.List name={["answers"]} initialValue={[{}]}>
      {(fields) => (
        <div>
          {fields.map(({ key, name, ...restField }) => {
            return (
              <Form.Item
                key={key}
                style={{ width: "100%" }}
                name={[name, "value"]}
                {...restField}
                rules={[
                  { required: true, message: "Molim vas upišite naputak." },
                ]}
              >
                <ReactQuill style={{ borderRadius: 8 }} theme="snow" />
              </Form.Item>
            );
          })}
        </div>
      )}
    </Form.List>
  );
};
